export const sellElements="Seller";
export const productionElements="Manufacturer";
export const setupElements="Installer";
export const designElements = "Designer";
export const customer = "Customer";